module.exports = __webpack_public_path__ + "img/share-25.dbdeac0a.jpg";